import { Component, Input, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'mj-date-visualiser',
  templateUrl: './mj-date-visualiser.component.html',
  styleUrls: ['./mj-date-visualiser.component.scss'],
})
export class MjDateVisualiserComponent implements OnInit {
  @Input()
  set selectedDate(value: Date) {
    this.renderDate(value);
  }

  months: string[];
  dateDayNumber: string;
  dateDayName: string;

  constructor(public translate: TranslateService) {}

  ngOnInit() {}

  private renderDate(date: Date) {
    if (!date) {
      return;
    }
    const pipe = new DatePipe(this.translate.currentLang);
    const previousMonth = new Date().setMonth(date.getMonth() - 1);
    const nextMonth = new Date().setMonth(date.getMonth() + 1);
    const afterNextMonth = new Date().setMonth(date.getMonth() + 2);
    this.months = [
      pipe.transform(previousMonth, 'LLLL'),
      pipe.transform(date, 'LLLL'),
      pipe.transform(nextMonth, 'LLLL'),
      pipe.transform(afterNextMonth, 'LLLL'),
    ];
    this.dateDayName = pipe.transform(date, 'EEEE');
    this.dateDayNumber = pipe.transform(date, 'd');
  }
}
